/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_State_UnknownInputs */

const vi_carrier_state_unknown = /** @type {(inputs: Carrier_State_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa xác định được vận đơn ở hãng. Kiểm tra trên hệ thống hãng trước khi huỷ.`)
};

/**

* @param {Carrier_State_UnknownInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_state_unknown = /** @type {((inputs?: Carrier_State_UnknownInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_State_UnknownInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_state_unknown(inputs)
});